import { memo, SyntheticEvent, useCallback } from 'react'
import cn from 'classnames'
import IconInformation from 'remixicon/icons/System/information-line.svg?react'

interface IProps {
  className?: string
  onOpenScheduler?: () => void
}

export const OrderCargoTotalInformation = memo<IProps>(function OrderCargoTotalInformation({
  className,
  onOpenScheduler
}) {
  const handleOpenScheduler = useCallback(
    (event: SyntheticEvent) => {
      event.preventDefault()
      onOpenScheduler?.()
    },
    [onOpenScheduler]
  )

  return (
    <div className={cn(className, 'mt-2 grid grid-cols-[auto_1fr] items-start gap-x-4 rounded bg-surface-variant p-3')}>
      <IconInformation className="text-on-surface-variant" containerSize="nm" size="xs" />
      <div>
        <ul className="ml-2 list-outside list-disc pl-2 text-on-surface">
          <li className="text-body-md">
            Расчёт по&nbsp;общему объёму/весу производится по&nbsp;тарифу &laquo;Гибкий&raquo;.
            <a className="link inline-block" href="#" onClick={handleOpenScheduler}>
              Показать требования тарифа к&nbsp;грузоместу.
            </a>
          </li>
          <li className="mt-1 text-body-md">
            Груз, сданный на поддоне/палете, будет принят к перевозке по тарифу «Палета».
          </li>
        </ul>
      </div>
    </div>
  )
})
